'use client';
import React, { ImgHTMLAttributes, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { FormControl, FormControlLabel, Checkbox } from '@mui/material';
import { Choice, Limit, ImageLimit, SelectionData } from '../questions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ClientComponent from '@/components/builder/client_component';
import cssStyles from "./questioniar_component.module.scss";
import { Box, Card, CardHeader, CardMedia, ImageList, ImageListItem, ImageListItemBar, styled } from '@mui/material';
import CommonCarouselComponent from '@/components/carousal/common_carousel';
import useScreenSize from '@/utils/useScreenSize';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));


const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  maxWidth: '80%',
  maxHeight: '75vh',
  padding: '20px',
  overflowY: 'auto'
};

const rowsColumnsDefinition = [{
  rows: 2,
  cols: 2,
},
{
  rows: 1,
  cols: 1
},
{
  rows: 1,
  cols: 1
},
{
  rows: 1,
  cols: 2,
},
{
  rows: 1,
  cols: 2,
},
{
  rows: 2,
  cols: 2,
},
{
  rows: 1,
  cols: 1
},
{
  rows: 1,
  cols: 1
}]

const VerticalMultiSelection: React.FC<SelectionData> = ({ selectedAnswer, setSelectedAnswer, choices, editData, label, props, isBudgetFlow }) => {
  const screenSize = useScreenSize();
  const componentRef = useRef<any>(null);
  const [componentWidth, setComponentWidth] = useState<any>(0);
  const itemsIndex = useRef<any>(0);
  useEffect(() => {
    if (componentRef.current) {
      setComponentWidth(componentRef.current.offsetWidth);
    }
  }, [])

  let previousChoiceId: string[] = [];
  const isValueChanged = useRef(false);

  const limit = props.imageGridMultiSelection ? ImageLimit : Limit;

  const makeUniqueArr = (choicesArr: any = []) => {
    choicesArr = choicesArr.filter((value: any) => value !== null && value !== undefined)
    const uniqueArray = Array.from(
      new Set(
        choicesArr.map((obj: any) => obj.choiceid)))
      .map(choiceid =>
        choicesArr.find((obj: any) => obj.choiceid === choiceid)
      );
    return uniqueArray
  }

  const getAnswersArr = (selectedValues: Array<string>) => {
    return selectedValues.map((eachValue) => {
      const answerObj = choices.filter((eachChoice: Choice) => eachChoice.choiceid === eachValue) as Choice[];
      if (answerObj.length > 0) {
        return {
          choiceid: eachValue,
          answer: answerObj[0].choice,
          image: answerObj[0].image
        }
      }
    }) || []
  }

  // choices = useMemo(() => {
  //   let previousChoiceId = [] as any;
  //   if(choices){
  //       previousChoiceId = editData.responses[0].answers.map((eachChoice:any)=> eachChoice.choiceid) || [];
  //   }
  //   return previousChoiceId;
  // },[choices])

  previousChoiceId = useMemo(() => {
    let previousChoiceId = [] as any;
    if (editData && editData.responses && editData.responses.length > 0 &&
      editData.responses[0].answers && editData.responses[0].answers.length > 0) {
      previousChoiceId = editData.responses[0].answers.map((eachChoice: any) => eachChoice.choiceid) || [];
    }
    return previousChoiceId;
  }, [editData])


  const [selectedValues, setSelectedValues] = useState(previousChoiceId);
  const items = useRef<Choice[]>([].concat(choices));
  const [updateDOM, setUpdateDOM] = useState(new Date().getMilliseconds());
  // const itemsIndex = useRef(choices.length);

  useLayoutEffect(() => {
    setUpdateDOM(new Date().getMilliseconds())
    // if(itemsIndex.current==0 && itemsIndex.current < limit) {
    //   //handleShowMore(null);
    // }
    // return () => {
    //   itemsIndex.current=0
    // }
  }, [])
  const handleShowLess = (e: React.MouseEvent<HTMLAnchorElement> | null) => {
    if (e) {
      e.preventDefault();
    }
    itemsIndex.current = limit;
    items.current.length = limit;
    setUpdateDOM(new Date().getMilliseconds())
  }

  const handleShowMore = (e: React.MouseEvent<HTMLAnchorElement> | null) => {
    if (e) {
      e.preventDefault();
    }
    const length = itemsIndex.current + limit > choices.length ? choices.length : itemsIndex.current + limit;

    for (let i = 0; i < choices.length; i++) {
      ++itemsIndex.current;
      items.current.push(choices[i]);

    }
    setUpdateDOM(new Date().getMilliseconds())
  }


  useEffect(() => {
    if (previousChoiceId && previousChoiceId.length > 0) {
      setSelectedAnswer((previousValues: any) => {
        let uniqueArr;
        if (isBudgetFlow && selectedAnswer) {
          uniqueArr = makeUniqueArr([...selectedAnswer, ...previousValues, ...getAnswersArr(previousChoiceId)]);
        } else {
          uniqueArr = makeUniqueArr([...previousValues, ...getAnswersArr(previousChoiceId)]);
        }

        return uniqueArr;
      })
    }
  }, [previousChoiceId])

  useEffect(() => {
    if (selectedValues.length > 0 && isValueChanged.current) {
      isValueChanged.current = false;
      setSelectedAnswer((previousValues: any) => {
        if (props.isPersonality) {
          return makeUniqueArr([...previousValues, ...getAnswersArr(selectedValues)])
        } else if (isBudgetFlow && selectedAnswer) {
          return makeUniqueArr([...selectedAnswer, ...previousValues, ...getAnswersArr(selectedValues)]);
        } else {
          return makeUniqueArr([...getAnswersArr(selectedValues)])
        }
      })
    } else if (selectedValues.length == 0) {
      if (isBudgetFlow && selectedAnswer) {
        setSelectedAnswer([...selectedAnswer])
      } else {
        setSelectedAnswer([])
      }
    }
  }, [selectedValues])


  const [selectedAnswerObj, setSelectedAnswerObj] = useState<Choice[]>();

  useEffect(() => {
    let selectedAnswerObj = items.current.filter((item) => {
      return selectedValues.includes(item.choiceid);
    });
    setSelectedAnswerObj(selectedAnswerObj);
  }, [items.current, selectedValues])


  const setAnswer = (event: React.ChangeEvent<HTMLInputElement>) => {
    const answerObj = choices.filter((eachChoice: Choice) => eachChoice.choiceid === event.target.value) as Choice[]
    //local state
    let values = [];
    isValueChanged.current = true;
    if (selectedValues.includes(event.target.value)) {
      //if already present remove from the array
      setSelectedValues(selectedValues.filter((eachChoiceId) => eachChoiceId != event.target.value))
    } else {
      setSelectedValues([...selectedValues, event.target.value]);
    }


  }

  function returnTemplateForCheckBoxes(option: any) {
    if (props.imageGridMultiSelection) {
      const template = (
        <div className={`${cssStyles["image-grid-multi-selection"]} ${props?.template?.show_label_on_hover ? cssStyles["show-label-on-hover"] : ''}`}>
          <img src={option.image} />
          {!props.styleQPref && (<span className={cssStyles["choice-backdrop"]}>{option.choice}</span>)}
        </div>
      )
      return template;
    } else {
      return <div dangerouslySetInnerHTML={{ __html: option.choice }}></div>
    }
  }

  function getClassForEachDiv(isSelectedValue: boolean) {
    if (!props.imageGridMultiSelection) {
      return `${cssStyles["groupBox"]} ${isSelectedValue ? cssStyles["selectedBox"] : cssStyles["unselectedBox"]}`
    } else {
      return `${cssStyles["imageDiv"]}`
    }
  }



  function srcset(image: string | undefined, size: number, rows = 1, cols = 1) {
    return {
      src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
      srcSet: `${image}?w=${size * cols}&h=${size * rows
        }&fit=crop&auto=format&dpr=2 2x`,
    };
  }

  const generateStyleCards = () => {
    const cardsDom: any[] = [];
    const imageFill = "cover";
    items.current?.forEach((card: any, index: number) => {
      cardsDom.push(
        <Card key={'styleType' + (card.name ? card.name : "") + index} className={`${cssStyles["selected_brand"]} ${cssStyles["brand_list"]}`} sx={{ m: 1, borderColor: selectedValues.includes(card.choiceid) ? 'primary.main' : 'transparent' }}>
          <Box component="div">
            <CardHeader
              sx={{
                padding: '0px',
                position: 'relative',
              }}
              title={
                <>
                  <CardMedia
                    image={card.image}
                    className={cssStyles["slide-image"]}
                    component="img"
                    sx={{
                      height: "180px",
                      objectFit: imageFill,
                    }}
                  />
                  <Checkbox
                    className={`${cssStyles['normal-checkbox']} ${selectedValues.includes(card.choiceid) ? cssStyles['checkbox-checked'] : ''}`}
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      zIndex: '1',
                      top: '0',
                      left: '0',
                      opacity: '0',
                    }}
                    checked={selectedValues.includes(card.choiceid)}
                    value={card.choiceid}
                    onChange={setAnswer}
                    checkedIcon={<CheckCircleIcon sx={{
                      color: 'primary.main',
                      backgroundColor: 'white',
                      borderRadius: '100%',
                      position: "absolute",
                      left: "20px",
                      top: "10px"
                    }} />}
                    icon={<CheckCircleOutlineIcon sx={{
                      color: 'secondary.main',
                      backgroundColor: 'white',
                      borderRadius: '100%',
                      position: "absolute",

                      left: "20px",
                      top: "10px"
                    }} />}
                    disableRipple={true}

                  />
                </>

              }>
            </CardHeader>
          </Box>
        </Card>
      );
    })
    return cardsDom
  }

  const [showAllBrandList, setShowAllBrandList] = useState(false);


  const toggleBrandListMweb = () => {
    setShowAllBrandList(!showAllBrandList);
  }

  return (
    <div ref={componentRef}>

      {
        (props?.show_more) ?
          <>
            {screenSize.width > 560 ? (
              <>
                <div style={{ padding: "20px 0", display: "inline-block", fontWeight: 'bold', textTransform: 'uppercase' }}>{label}</div>
                <div className={cssStyles.desktop_brand_list}>
                  <CommonCarouselComponent fullWidth={true} type="scrollable" cards={generateStyleCards()} />
                </div>
              </>
            ) : (
              <>
                <div className={cssStyles.selected_item_mweb}>
                  <div style={{display: "inline-block", fontWeight: 'bold', textTransform: 'uppercase' }} >{label}</div>                  
                </div>
                <div className={cssStyles.mobile_brand_list} style={{padding: '20px 0'}}>
                  <div className={`${cssStyles.placeholder_images}`}>
                    {
                      items.current.map((card: any, index: number) => {
                        return (
                          <>
                            <Box component="div" className={cssStyles.brand_item_mweb} sx={{
                              color: selectedValues.includes(card.choiceid) ? '#fff' : '#25282B',
                              backgroundColor: selectedValues.includes(card.choiceid) ? 'primary.main' : '#A0A4A8'
                            }}>
                              <Checkbox
                                className={`${cssStyles['normal-checkbox']} ${selectedValues.includes(card.choiceid) ? cssStyles['checkbox-checked'] : ''}`}
                                style={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "100%",
                                  zIndex: '1',
                                  top: '0',
                                  left: '0',
                                  opacity: '0',
                                }}
                                checked={selectedValues.includes(card.choiceid)}
                                value={card.choiceid}
                                onChange={setAnswer}
                                checkedIcon={<CheckCircleIcon sx={{
                                  color: 'primary.main',
                                  backgroundColor: 'white',
                                  borderRadius: '100%',
                                  position: "absolute",
                                  left: "20px",
                                  top: "10px"
                                }} />}
                                icon={<CheckCircleOutlineIcon sx={{
                                  color: 'secondary.main',
                                  backgroundColor: 'white',
                                  borderRadius: '100%',
                                  position: "absolute",

                                  left: "20px",
                                  top: "10px"
                                }} />}
                                disableRipple={true}

                              />
                              {card.choice}</Box>
                          </>
                        )
                      })
                    }                    
                  </div>   
                  {/* <Box onClick={toggleBrandListMweb} className={cssStyles.show_more_list}>{!showAllBrandList ? 'Show More' : 'Show Less'}</Box>               */}
                </div >
                
              </>
            )
            }
          </>
          //   <ImageList id={cssStyles[`image-irregular-grid`]}
          //   sx={{ width: componentWidth, height: "auto" }}
          //   variant="quilted"
          //   cols={4}
          //   rowHeight={121}>
          //       {
          //       items.current.map((item) => {

          //         let imgRowColDef = rowsColumnsDefinition[itemsIndex.current]

          //         if(itemsIndex.current >= rowsColumnsDefinition.length) {


          //           imgRowColDef = rowsColumnsDefinition[itemsIndex.current - rowsColumnsDefinition.length]
          //           itemsIndex.current = 0;
          //         }
          //         itemsIndex.current++;

          //         return (
          //           <ImageListItem style={{ display: "flex" }} key={item.image} cols={imgRowColDef.cols || 1} rows={imgRowColDef.rows || 1}>
          //              <img
          //               {...srcset(item.image, 121, imgRowColDef.rows, imgRowColDef.cols)}
          //               alt={item.choice}
          //               loading="lazy"
          //             />

          //             <Checkbox
          //               className={`${cssStyles['normal-checkbox']} ${selectedValues.includes(item.choiceid) ? cssStyles['checkbox-checked']: ''}`}
          //               style={{position: "absolute",
          //               width: "100%",
          //               height: "100%",
          //               }}
          //               checked={selectedValues.includes(item.choiceid)}
          //               value={item.choiceid}
          //               onChange={setAnswer}
          //               checkedIcon={<CheckCircleIcon sx={{color: 'primary.main', 
          //                               backgroundColor: 'white',
          //                               borderRadius: '100%', 
          //                               position: "absolute",
          //                               left: "20px",
          //                               top: "10px"}} />}
          //               icon={<CheckCircleOutlineIcon sx={{
          //                 color: 'secondary.main', 
          //                 backgroundColor: 'white', 
          //                 borderRadius: '100%', 
          //                 position: "absolute",

          //                 left: "20px",
          //                 top: "10px"}} />}
          //                 disableRipple={true}

          //             />

          //         </ImageListItem>
          //       )
          //       })
          //     }
          // </ImageList> : 
          :
          (<FormControl component="fieldset" className={cssStyles[`${(props.imageGridMultiSelection) ? "image-grid-parent" : "vertical-container"}`]}>

            <div className={`${cssStyles["normal-flow"]} ${props?.template?.num_cols ? cssStyles['num_cols_' + props?.template?.num_cols] : cssStyles['num_cols_3']}`}>
              {items.current.map((option) => {
                const isSelectedValue = selectedValues.includes(option.choiceid);
                return (

                  <Box component="div" key={option.choiceid} className={getClassForEachDiv(isSelectedValue)} sx={{
                    borderColor: isSelectedValue ? 'primary.main !important' : 'secondary.main !important'
                  }}>
                    <FormControlLabel
                      key={option.choiceid}
                      control={
                        <div className={cssStyles[`${(props.imageGridMultiSelection) ? "image-grid-checkbox" : "normal-checkbox"}`]}>
                          <Checkbox
                            checked={selectedValues.includes(option.choiceid)}
                            value={option.choiceid}
                            onChange={setAnswer}
                            checkedIcon={<CheckCircleIcon sx={{ color: 'primary.main', backgroundColor: 'white', borderRadius: '100%' }} />}
                            icon={<CheckCircleOutlineIcon sx={{ color: 'secondary.main', backgroundColor: 'white', borderRadius: '100%' }} />}
                          />
                        </div>}
                      label={returnTemplateForCheckBoxes(option)}
                    />
                  </Box>
                )
              })
              }
            </div>
          </FormControl>)
      }
      {/* {itemsIndex.current < choices.length ? <a href='#' className={cssStyles['show-more']} onClick={handleShowMore}>Show more <MoreVertIcon /></a> : itemsIndex.current <= limit ? "" :<a href='#' className={cssStyles['show-more']} onClick={handleShowLess}></a>/**Show less  }*/}
    </div>
  )

}

export default ClientComponent(VerticalMultiSelection);